<div class="page-container list-page mt-6 mb-6 pt-4">
    <h1 class="title is-1">Events</h1>
    <form [formGroup]="form" (ngSubmit)="search()">
        <div class="columns">
            <div class="column is-9">
                <div class="columns">
                    <div class="field column">
                        <label for="event-text-input">Search by text</label>
                        <div class="control is-expanded has-icons-left">
                            <input
                                formControlName="extractedText"
                                type="search"
                                class="input"
                                placeholder="Type text to search for events"
                                id="event-text-input"
                            />
                            <isav-icon icon="search" class="is-small is-left"></isav-icon>
                        </div>
                    </div>

                    <div class="field column">
                        <label for="event-start-date">Start date</label>
                        <div class="control is-expanded">
                            <input
                                id="event-start-date"
                                type="date"
                                class="input"
                                formControlName="startDate"
                            />
                        </div>
                    </div>

                    <div class="field column">
                        <label for="event-end-date">End date</label>
                        <div class="control is-expanded">
                            <input
                                id="event-end-date"
                                type="date"
                                class="input"
                                formControlName="endDate"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-3">
                <div class="field has-text-centered mt-5">
                    <div class="control">
                        <button type="submit" isavBtn color="success" class="simple-search-submit">
                            Search
                        </button>
                    </div>
                </div>

                <div class="field">
                    <div class="control has-text-centered has-text-white">
                        <a (click)="resetForm()" data-testid="resetbtn"> Reset </a>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <isav-mini-content-search *ngIf="searchState | async as searchState" [state]="searchState">
        <div class="columns is-multiline">
            <ng-container *ngFor="let event of searchState.results.member; let i = index">
                <ng-container
                    *ngIf="differentMonths(searchState.results.member[i-1]?.startEndDates[0]?.startDate,
                        event.startEndDates[0]?.startDate)"
                >
                    <div class="column is-12">
                        <h1 class="title is-1">
                            {{ event.startEndDates[0]?.startDate | isavMonthName }}
                        </h1>
                    </div>
                </ng-container>
                <isav-landing-card [image]="event.coverImage">
                    <ng-container isavLandingCardCaption>
                        {{ event.startEndDates[0]?.startDate | isavDate }} - {{
                        event.startEndDates[0]?.endDate | isavDate }}
                    </ng-container>
                    <a
                        isavLandingCardHeading
                        [routerLink]="linkTo(event)"
                        [queryParams]="{ iri: event['@id'] }"
                    >
                        {{ event.title }}
                    </a>
                    <div isavLandingCardFooter class="columns">
                        <div class="column">
                            <b>Location:&nbsp;</b><br />
                            {{ event.location }}
                        </div>
                        <div class="column">
                            <b>Activity:&nbsp;</b><br />
                            <isav-taxonomies-names
                                [iris]="[event.activity]"
                            ></isav-taxonomies-names>
                        </div>
                    </div>
                </isav-landing-card>
            </ng-container>
        </div>
    </isav-mini-content-search>
</div>
